export default __webpack_public_path__ + "static/media/office1-after1-1440w.cd1d9a2b.webp";